{
  "sdk-download-android": "Android සඳහා බාගත කරන්න",
  "sdk-connect": "සම්බන්ධ කරන්න",
  "sdk-download-ios": "iOS සඳහා බාගත කරන්න",
  "sdk-install": "ස්ථාපනය කරන්න",
  "sdk-modal-instruct-1": "1. Binance යෙදුම විවෘත කරන්න",
  "sdk-modal-instruct-2": "2. මුල් තිරයේ {{icon}} මත තට්ටු කරන්න",
  "sdk-modal-title": "Binance සමග සම්බන්ධ වන්න",
  "sdk-no-app": "තවමත් Binance යෙදුම නැති ද?"
}